import React from "react";
import Section from "@/Components/LayoutComponents/Section";
import dynamic from "next/dynamic";
const CustomSlider = dynamic(() => import("./CustomSlider"));

import { ServiceBlock } from "..";
import CustomAccordion from "./accordian";

interface ServiceProps {
  data?: ServiceBlock;
}

export interface SlideLink {
  id: number;
  href: any;
  label: any;
  target: string | null;
}

export interface SlideItem {
  id: number;
  tag: string;
  title: string;
  description: string;
  image: any;
  link?: SlideLink;
  onButtonClick?: () => void | string;
  thumbDescription?: any;
}

const Service: React.FC<ServiceProps> = ({ data }) => {
  return (
    <Section className="bg-[linear-gradient(96.18deg,_#E6F5FF_0%,_#5AA7DF_100%)] relative">
      <div className=" bg-[linear-gradient(0deg,_rgba(255,_255,_255,_0.8),_rgba(255,_255,_255,_0.8))] absolute z-[1] top-0 left-0 inset-0"></div>
      <div className=" bg-[url(/images/enterprise-bg.png)] bg-size-[60%] bg-no-repeat bg-left-top absolute z-[2] top-0 left-0 inset-0"></div>
      <div className="container relative z-[3]">
        <h2 className="text-heading-1 text-primary-text font-bold text-center capitalize max-w-[1230px] mx-auto">
          {data?.title}
        </h2>
        <div className="xl:mt-10 mt-8">
          <div className="hidden md:block">
            <CustomSlider
              SlideItem={data?.slide?.map((item) => ({
                ...item,
                onButtonClick:
                  typeof item.onButtonClick === "function"
                    ? item.onButtonClick
                    : () => { },
                thumbDescription: item.thumbDescription ?? { url: "" },
              }))}
            />
          </div>

          <div className="md:hidden">
            <CustomAccordion
              accordionItems={(data?.slide ?? []).map((item) => ({
                id: String(item.id),
                tag: item?.tag,
                title: item?.title,
                description: item?.description,
                image: item?.image,
                link: {
                  label: item?.link?.label,
                  url: item?.link?.href, // map 'href' to 'url'
                },
              }))}
            />
          </div>
        </div>
      </div>
    </Section>
  );
};
export default React.memo(Service);
